export default __webpack_public_path__ + "static/media/quiz-multi-select.ceaf51af.png";